import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetDocumentDetail = (documentId) => {
  const data = useQuery(
    ["documentDetail", documentId],
    () =>
      axiosClient.get(`/DocumentType/GetDocumentValueByDocumentId?documentId=${documentId}`),
    { enabled: !!documentId, refetchOnWindowFocus: false }
  );

  return data;
};
export default useGetDocumentDetail;
